<div class="paginatorButtons">
    <div class="flexLeftBaseline">
        <button mat-icon-button [disabled]="!paginateLeft"  (click)="paginators('-')" color="primary">
            <mat-icon *ngIf="paginateLeft">chevron_left</mat-icon>
            <mat-icon *ngIf="!paginateLeft" class="clearIcon">chevron_left</mat-icon>
        </button>
        <!-- <p> {{page}} / {{totalPages}}</p> -->
        <p> {{page}}</p>
        <button mat-icon-button [disabled]="!paginateRight" (click)="paginators('+')" color="primary">
            <mat-icon *ngIf="paginateRight">chevron_right</mat-icon>
            <mat-icon *ngIf="!paginateRight" class="clearIcon">chevron_right</mat-icon>
        </button>
    </div>
</div>